import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import {
  notification,
  Spin,
  Switch,
  Table,
  Typography,
  Space,
  Popconfirm,
  Input,
  Button,
  Select,
  Row,
  Col,
} from "antd";
import { PlusOutlined, ReloadOutlined } from "@ant-design/icons";

import BasicButtonPrimary from "components/BasicButtonPrimary";
import {
  CONFIG_DAY_SETTING_FIELD,
  CONFIG_SETTING_NOTIFICATION_FIELD,
  CONFIG_SETTING_TEMPLATE_KEY,
  CONFIG_SETTING_TEMPLATE_VALUE,
} from "constants/configListSettingField";
import StationMessageConfigsService from "services/StationMessageConfigsService";
import {
  MIN_COLUMN_WIDTH,
  NORMAL_COLUMN_WIDTH,
  EXTRA_BIG_COLUMND_WITDTH,
  VERY_BIG_COLUMN_WIDTH,
} from "constants/app";
import { BUTTON_LOADING_TIME } from "constants/time";
import BasicTablePaging from "components/BasicTablePaging/BasicTablePaging";
import { BIG_COLUMN_WIDTH } from "constants/app";

const { Option } = Select;

const ALL_OBJECT = { value: 99, label: "Tất cả" };
const STATUS = {
  ENABLE: { value: 1, label: "Bật" },
  DISABLE: { value: 0, label: "Tắt" },
};

const CustomerListSettings = () => {
  const { t: translation } = useTranslation();
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [dataSettings, setDataSettings] = useState({ total: 0, data: [] });
  const [enableConfig, setEnableConfig] = useState(undefined);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataFilter, setDataFilter] = useState({
    filter: {},
    skip: 0,
    limit: 20,
    searchText: undefined,
    endDate: undefined,
    startDate: undefined,
  });

  const fetchData = async () => {
    setLoading(true);
    try {
      const payload = {
        ...dataFilter,
        filter: {
          ...dataFilter.filter,
          enableConfig: enableConfig !== undefined ? enableConfig : undefined,
        },
      };
      const res =
        await StationMessageConfigsService.advanceUserGetStationListConfigs(
          payload
        );

      if (!res.isSuccess) throw new Error();

      setDataSettings({ total: res.total, data: res.data });
    } catch (error) {
      notification.error({
        message: "",
        description: translation("customerSettings.fetchDataError"),
      });
    } finally {
      setLoading(false);
    }
  };

  const updateStationMessageConfigs = async (id, status) => {
    setLoading(true);
    try {
      const res =
        await StationMessageConfigsService.updateStationMessageConfigs({
          messageConfigId: id,
          data: { enableConfig: status },
        });

      if (!res.isSuccess) throw new Error();

      notification.success({
        message: "",
        description: translation("customerSettings.updateSettingsSuccess"),
      });
      fetchData();
    } catch (error) {
      notification.error({
        message: "",
        description: translation("customerSettings.updateSettingsError"),
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dataFilter, enableConfig]);

  const handleDeleteConfig = (data) => {
    setLoading(true);
    StationMessageConfigsService.advanceUserDeleteStationMessageConfigById(data)
      .then((res) => {
        if (res.isSuccess) {
          notification.success({
            message: "",
            description: translation("customerSettings.deleteSuccess"),
          });
          fetchData();
        } else {
          notification.error({
            message: "",
            description: translation("customerSettings.deleteError"),
          });
        }
      })
      .catch(() => {
        notification.error({
          message: "",
          description: translation("customerSettings.deleteError"),
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // const columns = [
  //   {
  //     title: translation("landing.index"),
  //     key: "index",
  //     width: MIN_COLUMN_WIDTH,
  //     render: (_, __, index) => <div>{index + 1}</div>,
  //   },
  //   {
  //     title: translation("customerSettings.configTemplateName"),
  //     dataIndex: "configTemplateName",
  //     key: "configTemplateName",
  //     width: VERY_BIG_COLUMN_WIDTH,
  //     render: (text) => <div>{text || "Tên template"}</div>,
  //   },
  //   {
  //     title: translation("customerSettings.sendTime"),
  //     dataIndex: "autoSentTimes",
  //     key: "autoSentTimes",
  //     width: NORMAL_COLUMN_WIDTH,
  //     render: (record) =>
  //       record
  //         ? Object.keys(record).map((key) =>
  //             record[key] === STATUS.ENABLE.value ? (
  //               <div key={key}>{CONFIG_DAY_SETTING_FIELD[key]}</div>
  //             ) : null
  //           )
  //         : "Trống",
  //   },
  //   {
  //     title: translation("customerSettings.notificationType"),
  //     dataIndex: "notifyByLists",
  //     key: "notifyByLists",
  //     width: NORMAL_COLUMN_WIDTH,
  //     render: (record) =>
  //       record
  //         ? Object.keys(record).map((key) =>
  //             record[key] === STATUS.ENABLE.value ? (
  //               <div key={key}>{CONFIG_SETTING_NOTIFICATION_FIELD[key]}</div>
  //             ) : null
  //           )
  //         : "Trống",
  //   },
  //   {
  //     title: translation("customerSettings.templateNotification"),
  //     dataIndex: "messageTemplate",
  //     key: "messageTemplate",
  //     width: NORMAL_COLUMN_WIDTH,
  //     render: (record) =>
  //       !record || Object.keys(record).length === 0
  //         ? "-"
  //         : Object.keys(record).map((key) => {
  //             const templateId = record[key];
  //             const templateName = Object.keys(
  //               CONFIG_SETTING_TEMPLATE_KEY
  //             ).find(
  //               (configKey) =>
  //                 CONFIG_SETTING_TEMPLATE_KEY[configKey] === templateId
  //             );
  //             return (
  //               <div key={key}>
  //                 {templateName
  //                   ? CONFIG_SETTING_TEMPLATE_VALUE[templateName]
  //                   : null}
  //               </div>
  //             );
  //           }),
  //   },
  //   {
  //     title: (
  //       <Typography.Paragraph className="accreditation__title">
  //         Chi tiết
  //       </Typography.Paragraph>
  //     ),
  //     key: "details",
  //     width: NORMAL_COLUMN_WIDTH,
  //     render: (_, item) => (
  //       <BasicButtonPrimary
  //         onclick={() =>
  //           history.push(`/customer-setting-detail/${item.messageConfigId}`)
  //         }
  //         text="Chi tiết"
  //       />
  //     ),
  //   },
  //   {
  //     title: (
  //       <Typography.Paragraph className="accreditation__title">
  //         Hành động
  //       </Typography.Paragraph>
  //     ),
  //     key: "actions",
  //     width: MIN_COLUMN_WIDTH,
  //     align: "center",
  //     render: (_, item) => (
  //       <Space size="middle">
  //         <Switch
  //           checked={item.enableConfig === 1}
  //           onChange={(checked) =>
  //             updateStationMessageConfigs(item.messageConfigId, checked ? 1 : 0)
  //           }
  //         />
  //         <Popconfirm
  //           title={translation("customerSettings.confirm-delete")}
  //           okText={translation("category.yes")}
  //           cancelText={translation("category.no")}
  //           onConfirm={() => {
  //             handleDeleteConfig({ messageConfigId: item.messageConfigId });
  //           }}
  //         >
  //           <span style={{ cursor: "pointer", color: "var(--primary-color)" }}>
  //             {translation("listCustomers.delete")}
  //           </span>
  //         </Popconfirm>
  //       </Space>
  //     ),
  //   },
  // ];

  const columns = [
    {
      title: translation("landing.index"),
      dataIndex: "customerRecordId",
      key: "index",
      width: MIN_COLUMN_WIDTH,
      render: (_, __, index) => <div>{index + 1}</div>,
    },
    {
      title: translation("customerSettings.configTemplateName"),
      key: "configTemplateName",
      width: VERY_BIG_COLUMN_WIDTH,
      dataIndex: "configTemplateName",
      render: (text) => <div>{text || "Tên template"}</div>,
      width: EXTRA_BIG_COLUMND_WITDTH,
    },
    {
      title: translation("customerSettings.sendTime"),
      dataIndex: "autoSentTimes",
      key: "autoSentTimes",
      width: NORMAL_COLUMN_WIDTH,
      render: (record) => {
        if (!record) return "Trống";

        const { enableAutoSentNotiBeforeOtherDays, ...rest } = record;

        if (enableAutoSentNotiBeforeOtherDays > 0) {
          return `trước ${enableAutoSentNotiBeforeOtherDays} ngày`;
        }

        const enabledKeys = Object.keys(rest).filter(
          (key) => record[key] === STATUS.ENABLE.value
        );

        if (enabledKeys.length === 0) return "Trống";

        return (
          <>
            {enabledKeys.map((key) => (
              <div key={key}>{CONFIG_DAY_SETTING_FIELD[key]}</div>
            ))}
          </>
        );
      },
    },
    {
      title: translation("customerSettings.notificationType"),
      key: "notifyByLists",
      dataIndex: "notifyByLists",
      width: BIG_COLUMN_WIDTH,
      render: (record, data) => {
        console.log("data", data);
        return record ? (
          <>
            {Object.keys(record).map((key) =>
              record[key] === STATUS.ENABLE.value ? (
                <div key={key}>{CONFIG_SETTING_NOTIFICATION_FIELD[key]}</div>
              ) : null
            )}
            <div>{data?.enableAutoNotiSchedule === 1 ? translation("customerSettings.enableAutoNotiSchedule") : null}</div>
          </>
        ) : (
          "Trống"
        );
      },
    },
    {
      title: translation("customerSettings.templateNotification"),
      key: "messageTemplate",
      dataIndex: "messageTemplate",
      width: BIG_COLUMN_WIDTH,
      render: (record) => {
        const templateKeyById = Object.entries(
          CONFIG_SETTING_TEMPLATE_KEY
        ).reduce((acc, [key, id]) => {
          acc[id] = key;
          return acc;
        }, {});
        if (!record || Object.keys(record).length === 0) return "-";

        return Object.entries(record).map(([key, value]) => {
          const templateId = Number(value);
          const templateKey = templateKeyById[templateId];
          const templateLabel = CONFIG_SETTING_TEMPLATE_VALUE[templateKey];

          return <div key={key}>{templateLabel}</div>;
        });
      },
    },
    {
      title: () => (
        <Typography.Paragraph className="accreditation__title">
          Chi tiết
        </Typography.Paragraph>
      ),
      dataIndex: "details",
      key: "details",
      width: NORMAL_COLUMN_WIDTH,
      ellipsis: true,
      render: (_, item) => (
        <BasicButtonPrimary
          onclick={() =>
            history.push(`/customer-setting-detail/${item.messageConfigId}`)
          }
          text="Chi tiết"
        />
      ),
    },
    {
      title: () => (
        <Typography.Paragraph className="accreditation__title">
          Hành động
        </Typography.Paragraph>
      ),
      key: "actions",
      dataIndex: "customerRecordCheckExpiredDate",
      width: NORMAL_COLUMN_WIDTH,
      render: (_, item) => (
        <Space size="middle">
          <Switch
            checked={item.enableConfig === 1}
            onChange={(checked) =>
              updateStationMessageConfigs(item.messageConfigId, checked ? 1 : 0)
            }
          />
          <Popconfirm
            title={translation("customerSettings.confirm-delete")}
            okText={translation("category.yes")}
            cancelText={translation("category.no")}
            onConfirm={() => {
              handleDeleteConfig({ messageConfigId: item.messageConfigId });
            }}
          >
            <span style={{ cursor: "pointer", color: "var(--primary-color)" }}>
              {translation("listCustomers.delete")}
            </span>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleChangePage = (pageNum) => {
    const newFilter = {
      ...dataFilter,
      skip: (pageNum - 1) * dataFilter.limit,
    };
    setCurrentPage(pageNum);
    setDataFilter(newFilter);
  };

  return (
    <div>
      <Row gutter={[24, 24]} wrap align="start" justify="start" className="mb-3">
        <Col xl={4} lg={6} md={8} sm={12} xs={24}>
          <Input.Search
              autoFocus
              placeholder={translation("listCustomers.search")}
              onSearch={(value) => {
                const trimmedValue = value.trim();
                setDataFilter((prev) => ({
                  ...prev,
                  searchText: trimmedValue === "" ? undefined : trimmedValue,
                  skip: 0,
                }));
              }}
            />
        </Col>
        <Col xl={4} lg={6} md={8} sm={12} xs={24}>
          <Select
              className="w-100"
              placeholder={translation("customerSettings.status")}
              onChange={(value) => {
                setEnableConfig(value === 99 ? undefined : value);
                setDataFilter((prev) => ({
                  ...prev,
                  skip: 0,
                }));
              }}
            >
              <Option value={ALL_OBJECT.value}>{ALL_OBJECT.label}</Option>
              {Object.values(STATUS).map((item) => (
                <Option value={item.value} key={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
        </Col>
        <Col xl={16} lg={6} md={8} sm={12} xs={24} className="d-flex gap-4">
          <BasicButtonPrimary
            onclick={() => history.push("/customer-setting-create")}
            icon={<PlusOutlined className="addIcon" />}
            text={translation("inspectionProcess.add")}
            htmlType="button" // <-- Thêm dòng này
            className="d-flex justify-content-center align-items-center"
          />
          <Button
              type="default"
              loading={loading}
              disabled={loading}
              icon={<ReloadOutlined />}
              onClick={() => {
                setLoading(true);
                setTimeout(() => fetchData(), BUTTON_LOADING_TIME);
              }}></Button>
        </Col>
      </Row>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <Spin />
        </div>
      ) : (
        <>
          <Table
            className="noselect"
            dataSource={dataSettings.data}
            columns={columns}
            scroll={{ x: 1200 }}
            pagination={false}
          />
          <BasicTablePaging
            handlePaginations={handleChangePage}
            skip={dataFilter.skip}
            count={dataSettings?.data?.length < dataFilter?.limit}
            currentPage={currentPage}
          ></BasicTablePaging>
        </>
      )}
    </div>
  );
};

export default CustomerListSettings;
